import Vue from 'vue'
import Router from 'vue-router'
import Home from './pages/Home.vue'
import Terms from './pages/Terms.vue'
import Privacy from './pages/Privacy.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: { render (c) { return c('router-view') } },
      children: [
        {
          path: '',
          name: 'home',
          component: Home,
          meta: {
            title: 'TBD',
            description: ''
          }
        },
        {
          path: 'terms',
          name: 'terms',
          component: Terms,
          meta: {
            title: 'Terms of Service',
            description: ''
          }
        },
        {
          path: 'privacy',
          name: 'privacy',
          component: Privacy,
          meta: {
            title: 'Privacy policy',
            description: ''
          }
        }
      ]
    }
  ],
  scrollBehavior (_to, _from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

export default router
